import classNames from "classnames";
import React, { forwardRef, useEffect, useRef } from "react";
import { twMerge } from "tailwind-merge";

const FormInput = forwardRef(
    (
        {
            type = "text",
            id,
            name,
            value,
            autoComplete,
            required,
            isFocused,
            isError = false,
            handleChange,
            onBlur,
            placeholder = "",
            disabled = false,
            onInput,
            formValidate = {},
            max = '',
            className = "",
            placeholderClass = '',
            hoverClass = '',
            focusClass = '',
            errorClass = '',
            disabledClass = '',
        },
        ref
    ) => {
        const input = ref ? ref : useRef();

        useEffect(() => {
            if (isFocused) {
                input.current.focus();
            }
        }, []);

        const inputClass = classNames(
            // default
            twMerge(`w-full bg-white text-sm text-midnight font-light leading-none border border-steel-grey p-4 h-11.5 rounded-lg ${className}`),
            // placeholder
            twMerge(`placeholer:text-sm placeholder:leading-none placeholder:text-steel-grey ${placeholderClass}`),
            // focus
            twMerge(`focus:outline-none focus:border-silk-blue focus:bg-white focus:caret-silk-blue focus:placeholder:opacity-0 ${focusClass}`),
            //hover
            twMerge(`hover:bg-silk-blue/5 hover:border-silk-blue ${hoverClass}`),
            // error
            {
                [twMerge(`border-free-speech-red focus:border-free-speech-red ${errorClass}`)]: isError,
            },
            // disabled
            {
                [twMerge(`bg-platinum ${disabledClass}`)]: disabled,
            }
        );

        return (
            <input
                type={type}
                id={id ? id : name}
                name={name}
                value={value}
                className={twMerge(inputClass)}
                ref={input}
                autoComplete={autoComplete}
                required={required}
                onBlur={onBlur}
                onChange={handleChange}
                placeholder={placeholder ?? ""}
                disabled={disabled}
                onInput={onInput}
                max={max}
                {...formValidate}
            />
        );
    }
);

export default FormInput;
